import { resetRequest } from '../duck';
import getTabSelected from '../selectors/tabSelector';

const clearRequestThunk = () => (dispatch, getState) => {
  const state = getState();
  const lineOfBusiness = getTabSelected(state);
  dispatch(resetRequest(lineOfBusiness));
};

export default clearRequestThunk;
